<template>
  <div class="form-group">
    <multiselect v-model="selectedRequirements"
                 v-if="!loading"
                 :options="requirements"
                 :multiple="true"
                 :custom-label="customRequirementLabel"
                 :close-on-select="true"
                 :clear-on-select="false"
                 :hide-selected="true"
                 placeholder="Link requirements to issue"
                 track-by="requirement_id">
    </multiselect>
    <div v-else-if="loading">
      <div class="d-flex justify-content-center align-items-center">
        <icon  name="spinner" pulse scale="5"></icon>
      </div>
    </div>
  </div>
</template>

<script>
  import dialogMixin from '@/mixins/dialog'
  import utilsMixin from '@/mixins/utils'
  export default {
    data () {
      return {
        loading: true,
        requirements: [],
        selectedRequirements: []
      }
    },
    mixins: [dialogMixin, utilsMixin],
    mounted () {
      this.waitForAP()
      this.bindButtons()
    },
    methods: {
      bindButtons () {
        window.AP.dialog.disableCloseOnSubmit()
        window.AP.events.on('dialog.submit', () => {
          if (!this.loading) {
            this.loading = true
            this.submitData()
          }
        })
      },
      customRequirementLabel (requirement) {
        /* eslint-disable camelcase */
        const idToShow = requirement.display_id ? requirement.display_id : requirement.requirement_id
        return `${requirement.prefix}${idToShow}: ${requirement.name}`
        /* eslint-enable camelcase */
      },
      getLinkedRequirements () {
        this.$http.get(
          `/api/requirement?atlassian_project_id=${this.projectId}&atlassian_project_id=0&atlassian_issue_id=${this.issueId}`,
        ).then(response => {
          this.selectedRequirements = response.data.requirements
          this.loading = false
        }, response => {
          console.log('error')
        })
      },
      getRequirements () {
        this.$http.get(
          `/api/requirement?atlassian_project_id=${this.projectId}&atlassian_project_id=0`
        ).then(response => {
          this.requirements = response.data.requirements
          this.getLinkedRequirements()
        }, response => {
          window.AP.flag.create({
            title: 'Error',
            body: 'There was an error loading your requirements.  Please contact rmCloud support: support@purpledrapes.net',
            type: 'error'
          })
        })
      },
      waitForAP () {
        if (typeof window.AP !== 'undefined') {
          window.AP.dialog.getCustomData(customData => {
            this.issueId = customData.issueId
            this.projectId = customData.projectId
            this.getRequirements()
          })
        } else {
          setTimeout(this.waitForAP, 250)
        }
      },
      submitData () {
        this.$http.put(
          `/api/issue/${this.issueId}`,
          {
            requirements: this.selectedRequirements
          }).then(response => {
            this.loading = false
            window.AP.flag.create({
              title: 'Success!',
              body: 'Linked requirements saved successfully',
              type: 'success',
              close: 'auto'
            })
            window.AP.dialog.close()
          }, response => {
            this.loading = false
            window.AP.flag.create({
              title: 'Error',
              body: 'There was an error saving your linked requirements.  Please contact rmCloud support: support@purpledrapes.net',
              type: 'error'
            })
          })
      }
    }
    // Get all requirements
    // Also get requirements specific to this issue (passing in atlassian_issue_id)
    // Only make the ones already selected as selected
    // For submit, do a PATCH to just update the reuqirements
  }
</script>

<style scoped>
  footer {
    position: absolute;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// LinkRequirementsDialog.vue?33e36b5c